exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".yc-users[data-v-a42c1b88]{padding:20px}.page-head[data-v-a42c1b88]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:16px}.page-head h2[data-v-a42c1b88]{margin:0}.page-actions[data-v-a42c1b88]{display:-ms-flexbox;display:flex;gap:8px}.todo-tip[data-v-a42c1b88]{margin-top:16px}.muted[data-v-a42c1b88]{color:#bbb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a42c1b88","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/admin/views/yingchuan/UserData.vue
// module id = 150
// module chunks = 0